/**
 * Full-screen Terms & Conditions gate.
 *
 * Shown when a player has not yet accepted the T&C. Blocks all app access
 * until accepted.
 */

import { useState } from 'react';
import { api } from '../api/client.ts';
import { useT } from '../i18n/index.tsx';

interface Props {
  onAccepted: () => void;
}

export function TermsGate({ onAccepted }: Props) {
  const t = useT();
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    setLoading(true);
    try {
      await api.acceptTerms();
      onAccepted();
    } catch {
      setLoading(false);
    }
  };

  return (
    <div className="screen screen--centred gate">
      <h1 className="gate__title">{t.termsTitle}</h1>
      <p className="gate__hint" style={{ maxWidth: '40ch', textAlign: 'start' }}>
        {t.termsBody}
      </p>
      <button
        type="button"
        className="button button--primary button--wide"
        onClick={handleAccept}
        disabled={loading}
      >
        {loading ? '…' : t.termsAccept}
      </button>
    </div>
  );
}
